import axios from "../../../../api/axios";

import { PostsReportReasons } from "../types/postsReportReasons.types";

export const getPostsReportReasons = async (): Promise<PostsReportReasons.Response> => {
  const { data } = await axios.get("/lists/postsReportReasons");
  return data.items;
};
